import { LegacySalesPlatform } from "components/organisms/LegacySalesPlatformIFrame";

const ScheduleAppointment = () => {
  return <LegacySalesPlatform page="scheduleAppointment" />;
};

export { ScheduleAppointment };
